import React, { ErrorInfo } from 'react'

const RETRY_REFRESHED = 'retry-refreshed'
const CHUNK_LOAD_ERROR = 'ChunkLoadError'

interface ErrorBoundaryState {
  hasError: boolean
  error?: Error
  info?: ErrorInfo
}

export interface ErrorBoundaryProps {
  errorComponent?: React.ReactNode
  children?: React.ReactNode
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    hasError: false,
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  constructor(props: any) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch = (error: Error, info: ErrorInfo): void => {
    if (error.name === CHUNK_LOAD_ERROR) {
      const hasRefreshed = JSON.parse(window.sessionStorage.getItem(RETRY_REFRESHED) ?? 'false')
      if (!hasRefreshed) {
        window.sessionStorage.setItem(RETRY_REFRESHED, 'true')
        return window.location.reload()
      }
    }

    this.setState({ hasError: true, error, info })
  }

  render = (): React.ReactElement | React.ReactNode => {
    const { errorComponent } = this.props

    if (this.state.hasError) {
      if (errorComponent) return errorComponent
    }

    return this.props.children
  }
}

export default ErrorBoundary
